import { Assets, Graphics, TilingSprite, Container, Texture, Sprite, TextStyle } from 'pixi.js';
import { Point } from '../models/point';
import { GlowFilter } from 'pixi-filters';

export class PlayerTimebankProgressBar {
    container = new Container();

    private containerSize: Point = { x: 180, y: 4 };
    private barSize = { width: 252, height: 4 };
    private barDefaultColor = 0xFFFFFF;
    private barTimeBankColor = 0x0231df;

    private barBackgroundColor = 0xFFFFFF;
    private barCurrentColor = 0xFFFFFF;

    private bar: Graphics;
    private barBackground: Graphics;

    glowFilter: GlowFilter;


    constructor(position: Point) {
        this.container.position.set(position.x, position.y);

        this.glowFilter = new GlowFilter({
            distance: 12,
            outerStrength: 2,
            innerStrength: 2,
            color: this.barCurrentColor
        });

        this.barBackground = new Graphics();
        this.barBackground.roundRect(0, 0, this.barSize.width, this.barSize.height, 100).fill({ color: this.barBackgroundColor });
        this.barBackground.alpha = 0.2;
        this.container.addChild(this.barBackground);

        this.bar = new Graphics();
        this.bar.rect(0, 0, this.barSize.width, this.barSize.height).fill({ color: this.barCurrentColor });
        this.bar.filters = [this.glowFilter];
        this.container.addChild(this.bar);
    }

    update(newScale: number): void {
        const newWidth = this.barSize.width * newScale;
        this.bar.width = newWidth > this.barSize.width ? this.barSize.width : newWidth;

        this.bar.tint = this.barCurrentColor;
        this.glowFilter.color = this.barCurrentColor;
    }

    reset() {
        this.bar.tint = this.barCurrentColor;
        this.glowFilter.color = this.barCurrentColor;

        this.bar.clear();
        this.bar.rect(0, 0, this.barSize.width, this.barSize.height).fill({ color: this.barCurrentColor });
    }

    changeToTimebankColor() {
        this.barCurrentColor = this.barTimeBankColor;
    }

    changeToDefaultColor() {
        this.barCurrentColor = this.barDefaultColor;
    }

    destroy() {
        // 🔧 FIX: Explicitly destroy graphics to prevent canvas memory leaks
        if (this.barBackground) {
            this.barBackground.destroy({ children: true });
            this.barBackground = null as any;
        }
        if (this.bar) {
            this.bar.destroy({ children: true });
            this.bar = null as any;
        }
        
        this.container?.removeChildren();
        this.container?.destroy({ children: true, texture: false });
        this.container = null as any;
    }
}
